/*Products section*/
.productTypes,
.aboutUs,
.gallery,
.blog,
.reviews,
.faq,
.readyProducts,
.infoBar,
.blogList {
  padding: 2vw 12vw;
}

.readyProductsTitle {
  padding: 0vw 4vw;
}
.productTypesTitle,
.readyProductsTitle,
.aboutUsTitle,
.galleryTitle {
  text-align: center;
  margin-bottom: 50px;
  font-size: 22px;
  font-weight: 300;
  opacity: 0;
}

.galleryTitle {
  font-size: 2rem;
  font-weight: 300;
}

.aboutUsContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
}

.aboutUsDescription {
  padding: 20px 40px;
  width: 40%;
  box-shadow:
    rgba(0, 0, 0, 0.12) 0px 1px 3px,
    rgba(0, 0, 0, 0.24) 0px 2px 3px;
  margin-bottom: 20px;
  font-size: 14px;
}

.aboutUsDescription p {
  margin: 0;
}

.aboutImage {
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.createButton:hover .wardrobeIcon2 {
  filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
    hue-rotate(249deg) brightness(105%) contrast(103%);
}

.cartIcon {
  display: inline-block;
  height: 35px;
  width: 35px;
  background-size: cover;
  background-image: url(/cart2.svg);
}

.addToCartButton {
  padding: 0.1rem 1rem;
  width: fit-content;
  font-size: 1.2em;
  font-weight: 400;
  background-color: #fffdf7;
  border-color: #ef2a15;
  border-width: 2.5px;
  border-style: solid;
  color: #ef2a15;
  border-radius: 12px;
  cursor: pointer;
  font-family: 'Onest', sans-serif;
  display: flex;
  align-items: center;
  justify-items: baseline;
}

.addToCartButton:hover {
  background-color: #f46d5e;
  border-color: #f46d5e;
  color: #fffdf7;
  box-shadow: none;
}

.addToCartButton:hover .cartIcon {
  filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
    hue-rotate(249deg) brightness(105%) contrast(103%);
}

.ctaButtonContainer {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}

.contactBoxContainer {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .blog {
    padding: 0;
  }
  .aboutUsContent {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  .readyProducts {
    padding: 2vw 10px;
  }
  .aboutUsDescription {
    width: 90%;
    padding: 20px;
  }

  .aboutImage {
    width: 200px;
    height: 200px;
  }
}
